import {useTranslation} from 'react-i18next'

import {Dfn, TextLink} from '@sdox/ui'
import {IconWarning} from '@sdox/icons'

import type {XcNwBlock_BlockErrorType_Fragment} from '@sdox/api'

export const BlockErrorType = ({message, sentryLink, eventId}: XcNwBlock_BlockErrorType_Fragment) => {
  const {t} = useTranslation()

  return (
    <div className={'space-y-spacing-12'}>
      <p className={'flex items-center gap-spacing-12'}>
        <IconWarning className={'size-spacing-48'} />
        <h3 className={'grow text-h3'}>{message}</h3>
      </p>
      <p>
        {t('common:error.informedAndAsap')}
      </p>
      {eventId ? (
        <p>
          <Dfn>
            Error Code: {eventId}
          </Dfn>
        </p>
      ) : null}
      {sentryLink ? (
        <p>
          <TextLink
            href={sentryLink}
            target={'_blank'}
          >
            Sentry link
          </TextLink>

        </p>
      ) : null}
    </div>
  )
}